/*
 * @Author: Latte
 * @Date: 2021-08-16 11:28:39
 * @LAstEditors: Latte
 * @LastEditTime: 2021-08-16 17:15:33
 * @FilePath: \Siui.Cloud.Medical.Web\src\api\diagnosisManagement\joinTeamRequest.js
 */

import request from '@/utils/request'
import config from '@/utils/config'

/**
 * @description: 通过入团申请
 * @param {*} data
 * @return {*}
 */
export function allowReq(data) {
  return request({
    url: config.API_TELEMEDICINE + '/tel_server/manage/consultation/team/user/req/audit',
    method: 'patch',
    data
  })
}

/**
 * @description: 删除入团申请
 * @param {*} params
 * @return {*}
 */
export function deleteReq(params) {
  return request({
    url: config.API_TELEMEDICINE + '/tel_server/manage/consultation/team/user/req/deleteOrBack',
    method: 'delete',
    params
  })
}

/**
 * @description: 恢复入团申请
 * @param {*} params
 * @return {*}
 */
export function resumeReq(params) {
  return request({
    url: config.API_TELEMEDICINE + '/tel_server/manage/consultation/team/user/req/deleteOrBack',
    method: 'delete',
    params
  })
}

/**
 * @description: 获取单个入团申请详情
 * @param {*} params
 * @return {*}
 */
export function getReqDetail(params) {
  return request({
    url: config.API_TELEMEDICINE + '/tel_server/manage/consultation/team/user/req/detail',
    method: 'get',
    params
  })
}

/**
 * @description: 获取所有入团申请列表
 * @param {*} params
 * @return {*}
 */
export function getAllReqList(params) {
  return request({
    url: config.API_TELEMEDICINE + '/tel_server/manage/consultation/team/user/req/list',
    method: 'get',
    params
  })
}